
export const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0m';
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    if (hours > 0) {
      return `${hours}h ${mins}m`;
    } else if (mins > 0) {
      return `${mins}m${secs > 0 ? ` ${secs}s` : ''}`;
    } else {
      return `${secs}s`;
    }
  };